import { createSelector } from '@reduxjs/toolkit';
import {
  navigationPath,
  NavigationPathProps,
} from '../../../../navigations/navigationPath';
import {
  getDeviceIdFromQueryParam,
  getDeviceSelectedName,
} from '../../../../../../redux/devices/selectors';
import {
  getGroupIdQueryParam,
  getGroups,
  getGroupSelectedByQueryParamSelector,
} from '../../../../../../redux/groups/selectors';
import { RootState } from '../../../../../../redux/store.model';

const dicTitles: Record<string, string> = {
  history: 'device.monitoring.title',
  incidents: 'incident_manager.title',
};

const getProps = (_: RootState, props: NavigationPathProps) => props;

export const getDeviceSectionsNavigationSelector = createSelector(
  [
    getProps,
    getGroupIdQueryParam,
    getDeviceIdFromQueryParam,
    getGroups,
    getGroupSelectedByQueryParamSelector,
    getDeviceSelectedName,
  ],
  (props, groupId, deviceId, groups, group, deviceName) => {
    const url = groupId
      ? `/devicemanager/device/${deviceId}/group/${groupId}/device-detail/`
      : `/devicemanager/device/${deviceId}/device-detail/`;
    const navigators = navigationPath(props, groupId, groups, group).concat([
      {
        content: deviceName || '...',
        onClick: () => {
          history.push(url);
        },
      },
    ]);
    /** module selected */
    const {
      polyglot,
      history,
      location: { pathname },
    } = props;
    const moduleSelected = pathname.split('device-detail/')[1] ?? '';

    if (moduleSelected) {
      navigators.push({
        content: polyglot.t(dicTitles[moduleSelected] ?? ''),
        onClick: () => history.push(`${url}/${moduleSelected}`),
      });
    }
    return navigators;
  }
);
